module.exports = __webpack_public_path__ + "vikatan-logo-7d10e0f8c3899d298242.png";